import {
    NEEDS_ANALYSIS,
    INCOME_REPLACEMENT,
} from './ProgressChartConstants';

export const
    computeChartIndex = (isSpouse, section) => {
        switch (section) {
            case NEEDS_ANALYSIS:
                return isSpouse ? 2 : 0;
            case INCOME_REPLACEMENT:
                return isSpouse ? 3 : 1;
            default:
                throw "Invalid section";
        }
    },
    computeChartStringKey = (owner, section, fpId, clientId) => {
        return `ILPC_${owner}_${section}_${fpId}_${clientId}`;
    };